import cx from 'classnames';
import React, { useContext } from 'react';

import { ToolbarContext } from './../../ricos-context';
import type { IToolbarItem } from './../../ricos-types';

import styles from './url-link-button-scss';

export const AnchorLinkButton = ({ toolbarItem }: { toolbarItem: IToolbarItem }) => {
  const { isMobile, t } = useContext(ToolbarContext);
  const dataHook = toolbarItem.presentation?.dataHook;

  return (
    <div className={styles.toolbarUrlContainer}>
      <button
        data-hook={dataHook}
        className={cx(styles.toolbarUrl, styles.toolbarUrlAnchor, isMobile && styles.isMobile)}
        onClick={e => {
          e.preventDefault();
          toolbarItem.commands.click();
        }}
        onMouseDown={e => {
          // Prevents the editor from losing focus
          e.preventDefault();
        }}
        type="button"
      >
        {t('LinkTo_Toolbar_GoTo')}
      </button>
    </div>
  );
};
